export const isInvalidQuery = (query: string) => {
  const stringContent = query.toString();
  const prohibitedKeywordsRegex = new RegExp('\\b(insert|update|delete)\\b');
  return prohibitedKeywordsRegex.test(stringContent);
};
